import axios from "axios";
import { ResponseCode } from "services/organizationPortalClient";
import errorStore from "stores/errorStore";
import { LOGIN_ROUTE, ORGANIZATION_BASE_URL } from "config/paths";
import { OrganizationContextStorage } from "utils/organizationContextStorage";
import { StatusCodes, buildLoginRedirectUrl } from "@knowfully/ui.common";

const axiosInstance = axios.create({
  baseURL: ORGANIZATION_BASE_URL,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
  },
});

const createNoContentResponse = () => ({
  status: StatusCodes.NO_CONTENT,
});

axiosInstance.interceptors.request.use((config) => {
  const contextStore = OrganizationContextStorage.get();
  if (contextStore?.organization) {
    config.headers["X-API-ORGANIZATION-ID"] = contextStore?.organization.id;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    if (
      response?.data?.responseCode === ResponseCode.BusinessRuleFailed ||
      response?.data?.responseCode === ResponseCode.ValidationFailed
    ) {
      return Promise.reject(response);
    }
    return response;
  },
  (error) => {
    const status = error.status ?? error.response?.status;

    if (status === StatusCodes.UNAUTHORIZED) {
      const pathname = window.location.pathname;
      const requestedUrl = pathname === LOGIN_ROUTE ? "/" : pathname;
      window.location.replace(buildLoginRedirectUrl(requestedUrl));
      return Promise.resolve(createNoContentResponse());
    }

    if (status === StatusCodes.FORBIDDEN && window.location.pathname !== "/unauthorized") {
      window.location.href = "/unauthorized";
      return Promise.resolve(createNoContentResponse());
    }

    if (status === StatusCodes.INTERNAL_SERVER_ERROR && window.location.pathname !== "/error") {
      errorStore.update((s) => {
        s.url = error.response?.config?.url ?? "";
        s.message = error.message;
        s.operationId = error.response?.data?.data?.operationId;
        s.error = true;
      });
      window.location.href = "/error";
      return Promise.resolve(createNoContentResponse());
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
